import RangeFilterWrapper from './RangeFilterWrapper.component';

export default RangeFilterWrapper;